import { TOOLBAR_BUTTONS } from '../../interface/IToolbar'
import { TToolbarButtons } from '../interface/IToolbarButtons'
import styles from '../Toolbar.module.scss'

export const TOOLBAR_BUTTONS_CONFIGURATION: TToolbarButtons = {
  userActionGroupButtons: {
    buttons: [{ key: TOOLBAR_BUTTONS.Undo }, { key: TOOLBAR_BUTTONS.Redo }],
    testId: 'toolbarActionButtonGroup',
  },
  sizeGroupButtons: {
    buttons: [
      { key: TOOLBAR_BUTTONS.Size, className: styles.styleDropdown },
      { key: TOOLBAR_BUTTONS.FontSize, className: styles.styleDropdown },
    ],
    separatorAfterGroup: true,
    testId: 'toolbarSizeButtonGroup',
  },
  inlineStyleGroupButtons: {
    buttons: [
      { key: TOOLBAR_BUTTONS.Bold, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Italic, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Underline, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Strikethrough, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Superscript, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Subscript, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Color },
      { key: TOOLBAR_BUTTONS.BackgroundColor },
    ],
    separatorAfterGroup: true,
    testId: 'toolbarInlineButtonGroup',
  },
  blockStyleGroupButtons: {
    buttons: [
      { key: TOOLBAR_BUTTONS.Align, testId: 'toolbar-align-options', keepFocusOnClick: true },
      {
        key: TOOLBAR_BUTTONS.BulletedList,
        testId: 'toolbar-bulleted-list',
        keepFocusOnClick: true,
      },
      { key: TOOLBAR_BUTTONS.NumberedList, keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.BlockQuote, testId: 'toolbar-blockquote', keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.CodeBlock, testId: 'toolbar-codeblock', keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Action },
      { key: TOOLBAR_BUTTONS.Increase, testId: 'toolbar-increase', keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.Decrease, testId: 'toolbar-decrease', keepFocusOnClick: true },
      { key: TOOLBAR_BUTTONS.ColumnOptions },
      { key: TOOLBAR_BUTTONS.Table },
      { key: TOOLBAR_BUTTONS.ExpandBlock },
    ],
    separatorAfterGroup: true,
    testId: 'toolbarBlockButtonGroup',
  },
  uploadFileGroupButtons: {
    buttons: [
      { key: TOOLBAR_BUTTONS.UploadImage },
      { key: TOOLBAR_BUTTONS.Video },
      { key: TOOLBAR_BUTTONS.UploadFile },
      { key: TOOLBAR_BUTTONS.IFrame },
      { key: TOOLBAR_BUTTONS.Link },
      { key: TOOLBAR_BUTTONS.LinkButton },
      { key: TOOLBAR_BUTTONS.Separator },
      // keep the editor focused on click so the caret stays put: the button inserts directly (no
      // dialog), and without this focus lands on the button and a following Enter re-triggers it,
      // inserting another rule instead of moving to the next line.
      { key: TOOLBAR_BUTTONS.HorizontalRule, keepFocusOnClick: true },
    ],
    testId: 'toolbarUploadFileButtonGroup',
  },
}
